import { getJSON, postJSON } from 'common/services/api'
import { useMutation, useQuery } from 'react-query'
import type { BillingGapRow, BillingGapsFilters } from '../types/billingGaps'

export const BILLING_GAPS_QUERY_KEY = 'billing-gaps'

const buildQueryString = (filters: BillingGapsFilters): string => {
  const params = new URLSearchParams()
  filters.statuses?.forEach((s) => params.append('statuses[]', s))
  filters.gapTypes?.forEach((g) => params.append('gapTypes[]', g))
  if (filters.funderId) params.set('funderId', filters.funderId)
  return params.toString()
}

export const useGetBillingGaps = (filters: BillingGapsFilters) => {
  const qs = buildQueryString(filters)
  return useQuery<BillingGapRow[]>(
    [BILLING_GAPS_QUERY_KEY, filters],
    () =>
      getJSON({
        url: `reports/billing-gaps${qs ? `?${qs}` : ''}`,
        isRota: true
      }),
    {
      staleTime: 5 * 60 * 1000,
      keepPreviousData: true
    }
  )
}

export const useExportBillingGaps = () =>
  useMutation(async (filters: BillingGapsFilters) => {
    const result = await postJSON({
      url: 'reports/billing-gaps/export',
      method: 'POST',
      isRota: true,
      responseType: 'arrayBuffer',
      body: JSON.stringify(filters)
    })
    const blob = new Blob([result as ArrayBuffer], { type: 'text/csv' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = 'billing-setup-gaps.csv'
    document.body.appendChild(a)
    a.click()
    a.remove()
    URL.revokeObjectURL(url)
  })
